<div class="coworker-home-container">
  <div class="header">
    <span></span>
    <h3>{{ "coworker.booking.title" | translate }}</h3>
    <img [src]="getCloseIcon" (click)="goBack()"/>
  </div>
  <div class="container">
    <div class="wrapper" *ngIf="spaces.length">
      <span class="title">{{ "coworker.booking.space" | translate }}</span>
      <div class="horizontal-list">
        <coworking-space-card
          *ngFor="let space of spaces"
          [space]="space"
          [selected]="selectedSpace === space"
          (click)="setNewSpace($event)"
        >
        </coworking-space-card>
        <p *ngIf="inactiveSpaces" class="error">
          {{ "coworker.booking.no-active-space" | translate }}
        </p>
      </div>
    </div>

    <div class="wrapper">
      <span class="title">{{ "coworker.booking.duration" | translate }}</span>
      <div class="horizontal-list" *ngIf="selectedSpace">
        <cowing-element
          *ngFor="let duration of durations"
          [label]="duration.title"
          (event)="setNewDuration($event)"
          [selected]="selectedDuration === duration"
        >
        </cowing-element>
      </div>
      <p *ngIf="!selectedSpace" class="disclaimer">
        {{ "coworker.booking.select-space" | translate }}
      </p>
    </div>

    <div class="wrapper">
      <span class="title">{{ "coworker.booking.start-day" | translate }}</span>
      <div class="datepicker-wrapper">
        <cowing-datepicker (click)="setNewDay($event)"></cowing-datepicker>
      </div>
    </div>

    <div class="wrapper">
      <span class="title">{{ "coworker.booking.finish-day" | translate }}</span>
      <div class="datepicker-wrapper">
        <cowing-datepicker
          [disabled]="'true'"
          [value]="finishDay"
        ></cowing-datepicker>
      </div>
    </div>

    <div class="wrapper">
      <span class="title">{{ "coworker.booking.start-hour" | translate }}</span>
      <div class="datepicker-wrapper">
        <cowing-timepicker
          [disabled]="!isHourEnabled()"
          [inputStyle]="EInputStyleType.Rounded"
          [isForm]="false"
          [placeholder]="''"
          [value]="startHour"
          (newValue)="setStartHours($event)"
        >
        </cowing-timepicker>
      </div>
    </div>

    <div class="wrapper">
      <span class="title">{{
        "coworker.booking.finish-hour" | translate
      }}</span>
      <div class="datepicker-wrapper">
        <cowing-timepicker
          [disabled]="!isHourEnabled()"
          [inputStyle]="EInputStyleType.Rounded"
          [isForm]="false"
          [placeholder]="''"
          [value]="finishHour"
          (newValue)="setFinishHours($event)"
        >
        </cowing-timepicker>
      </div>
    </div>

    <div class="errors">
      <span class="error" *ngIf="isError">{{
        "coworker.booking.error" | translate
      }}</span>
      <span class="error" *ngIf="isClosed">{{
        "coworker.booking.closed" | translate
      }}</span>
    </div>
  </div>
  <div class="footer">
    <span class="title">{{ public_price }} Cowings</span>

    <cowing-button
      class="content-bottom"
      [label]="'Reservar'"
      (event)="showConfirmation()"
      [type]="EButtonType.MiniRounded"
      [iconShow]="true"
      [iconName]="'arrowRight'"
      [disabled]="!canBooking() || isError || isClosed"
    >
    </cowing-button>
  </div>
</div>
